import React from "react";
import { SafeAreaView, StyleSheet, View, Platform, ImageBackground, Image } from "react-native";
import Constants from "expo-constants";
import { StatusBar } from "expo-status-bar";
import { Video } from "expo-av";
import { useFocusEffect } from "@react-navigation/native";

import AppTitleBar from "./AppTitleBar";
import AppButtonGoBack from "../components/buttons/AppButtonGoBack";
import PopUpBox from "./PopUpBox";
import config from "../config/config";

function Screen({
    children,
    style,
    title,
    leftIconComponent,
    midLeftIconComponent,
    midRightIconComponent,
    rightIconComponent,
    subTitle,
    titleComponent,
    yesNo,
    loading,
    showTitleBar = true,
    backgroundColor = false,
    logo = false,
    backgroundImage = false,
    video = false,
}) {
    const videoRef = React.useRef(null);

    useFocusEffect(
        React.useCallback(() => {
            if (Platform.OS != "web" && video) {
                videoRef.current.playAsync();
            }
        }, [])
    );

    return (
        <View style={{ backgroundColor: backgroundColor ? backgroundColor : config.colors.grey, width: "100%", height: "100%" }}>
            <ImageBackground
                source={backgroundImage ? backgroundImage : require("../assets/background.png")}
                resizeMode="cover"
                style={{ width: "100%", height: "100%", zIndex: -2 }}
            >
                {/*  {logo && (
                    <Image style={{ width: 310, height: 130, marginTop: 50, position: "absolute", alignSelf: "center" }} source={require("../assets/logo-busybee.png")} />
                )} */}

                {/*            {Platform.OS != "web" && video && (
                    <Video
                        ref={videoRef}
                        style={{ width: "100%", height: "85%", position: "absolute", zIndex: -2 }}
                        source={require("../assets/videos/ukmap.mp4")}
                        resizeMode="cover"
                        isLooping
                        shouldPlay
                    />
                )} */}
                <SafeAreaView style={[styles.screen, style]}>
                    <PopUpBox yesNo={yesNo} />
                    {showTitleBar && (
                        <AppTitleBar
                            title={title}
                            subTitle={subTitle}
                            leftIconComponent={leftIconComponent ? leftIconComponent : <AppButtonGoBack />}
                            midLeftIconComponent={midLeftIconComponent}
                            midRightIconComponent={midRightIconComponent}
                            rightIconComponent={rightIconComponent}
                            titleComponent={titleComponent}
                        />
                    )}
                    <View style={[styles.view, style]}>{children}</View>
                    <StatusBar style="light" />
                </SafeAreaView>
            </ImageBackground>
        </View>
    );
}

const styles = StyleSheet.create({
    screen: {
        paddingTop: Platform.OS === "web" ? 0 : Constants.statusBarHeight,
        flex: 1,
    },
    view: {
        flex: 1,
    },
});

export default Screen;
